import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState, StateFromRoot, registerReducer } from "@core/store"
import {
  applyPageSelection,
  toggleChat as toggleChatUtil,
} from "../utils/mailingSelection"

const STATE_KEY = "chatsSelection"
export interface ChatsSelectionState {
  selectedChatIds: number[]
}

const initialState: ChatsSelectionState = { selectedChatIds: [] }

const chatsSelectionSlice = createSlice({
  name: STATE_KEY,
  initialState,
  reducers: {
    toggleChat: (state, action: PayloadAction<number>) => {
      state.selectedChatIds = toggleChatUtil(
        state.selectedChatIds,
        action.payload,
      )
    },
    setPageSelection: (
      state,
      action: PayloadAction<{ pageIds: number[]; selectedIds: number[] }>,
    ) => {
      state.selectedChatIds = applyPageSelection(
        state.selectedChatIds,
        action.payload.pageIds,
        action.payload.selectedIds,
      )
    },
    clearSelection: () => ({ selectedChatIds: [] }),
  },
})

registerReducer(chatsSelectionSlice.name, chatsSelectionSlice.reducer)

export const chatsSelectionReducer = chatsSelectionSlice.reducer

export const { toggleChat, setPageSelection, clearSelection } =
  chatsSelectionSlice.actions

const EMPTY_SELECTION: number[] = []

export const selectSelectedChatIds = (
  state: RootState<StateFromRoot<ChatsSelectionState>>,
) => state.chatsSelection?.selectedChatIds ?? EMPTY_SELECTION
